<template>
  <div class="gx-ann">
    <top-banner :show-notification="true" @logo="goHome">
      <template #center>
        <button class="gx-ann__back" @click="$router.back()">
          <i class="el-icon-arrow-left"></i>返回工作台
        </button>
      </template>
    </top-banner>

    <div class="gx-ann__box">
      <div class="gx-ann__head">
        <h1 class="gx-ann__title">公告中心</h1>
        <span v-if="unreadCount > 0" class="gx-ann__unread">{{ unreadCount }} 条未读</span>
      </div>

      <div class="gx-ann__filters">
        <div class="gx-ann__tabs">
          <button
            v-for="t in typeTabs"
            :key="'type-' + t.value"
            class="gx-ann__tab"
            :class="{ 'gx-ann__tab--on': typeFilter === t.value }"
            @click="changeType(t.value)"
          >{{ t.label }}</button>
        </div>
        <div class="gx-ann__tabs">
          <button
            v-for="t in readTabs"
            :key="'read-' + t.value"
            class="gx-ann__tab"
            :class="{ 'gx-ann__tab--on': readFilter === t.value }"
            @click="changeRead(t.value)"
          >{{ t.label }}</button>
        </div>
      </div>

      <div v-loading="loading" class="gx-ann__list">
        <div v-if="!loading && !list.length" class="gx-ann__empty">
          <div class="gx-ann__empty-icon">📢</div>
          <div>暂无公告</div>
        </div>

        <div
          v-for="item in list"
          :key="item.id"
          class="gx-ann__item"
          :class="{ 'gx-ann__item--unread': !item.is_read }"
          @click="goDetail(item)"
        >
          <span v-if="!item.is_read" class="gx-ann__dot"></span>
          <div v-if="item.cover_url" class="gx-ann__cover">
            <img :src="item.cover_url" alt="" />
          </div>
          <div class="gx-ann__body">
            <div class="gx-ann__row">
              <span class="gx-ann__tag" :class="'gx-ann__tag--' + (item.type || 'update')">{{ typeLabel(item.type) }}</span>
              <span v-if="item.important" class="gx-ann__tag gx-ann__tag--important">重要</span>
              <span class="gx-ann__item-title">{{ item.title }}</span>
              <span class="gx-ann__time">{{ formatTime(item.published_at || item.start_at) }}</span>
            </div>
            <p class="gx-ann__summary">{{ itemSummary(item) }}</p>
          </div>
        </div>
      </div>

      <div v-if="total > pageSize" class="gx-ann__pager">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="page"
          :page-size="pageSize"
          :total="total"
          @current-change="fetchList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TopBanner from '@/components/newUi/TopBanner.vue'
import { announcementList, announcementUnread } from '@/api/main/announcement'

export default {
  name: 'AnnouncementListPage',
  components: { TopBanner },
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 20,
      total: 0,
      typeFilter: '',
      readFilter: 'all',
      unreadCount: 0,
      typeTabs: [
        { value: '', label: '全部' },
        { value: 'update', label: '系统更新' },
        { value: 'activity', label: '活动' }
      ],
      readTabs: [
        { value: 'all', label: '全部' },
        { value: 'unread', label: '未读' }
      ]
    }
  },
  created() {
    this.fetchUnread()
    this.fetchList()
  },
  methods: {
    goHome() {
      this.$router.push('/ucenter')
    },
    typeLabel(type) {
      return type === 'activity' ? '活动' : '系统更新'
    },
    itemSummary(item) {
      const raw = item.summary || item.content_text || String(item.content || '').replace(/<[^>]+>/g, '')
      const text = raw.replace(/\s+/g, ' ').trim()
      return text.length > 80 ? text.slice(0, 80) + '…' : text
    },
    formatTime(ts) {
      if (!ts) return ''
      const d = new Date(typeof ts === 'number' && ts < 1e12 ? ts * 1000 : ts)
      if (isNaN(d.getTime())) return String(ts)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    changeType(v) {
      this.typeFilter = v
      this.page = 1
      this.fetchList()
    },
    changeRead(v) {
      this.readFilter = v
      this.page = 1
      this.fetchList()
    },
    async fetchUnread() {
      try {
        const res = await announcementUnread()
        if (res && res.code === 200) {
          this.unreadCount = (res.data && (res.data.count || res.data.unread_count)) || 0
        }
      } catch (e) { /* ignore */ }
    },
    async fetchList() {
      this.loading = true
      try {
        const params = { page: this.page, page_size: this.pageSize }
        if (this.typeFilter) params.type = this.typeFilter
        if (this.readFilter === 'unread') params.unread_only = 1
        const res = await announcementList(params)
        if (res && res.code === 200) {
          const data = res.data || {}
          this.list = data.list || data.items || data.data || []
          this.total = data.total || data.count || this.list.length
        } else {
          this.list = []
          this.total = 0
          this.$message && this.$message.error((res && res.msg) || '加载失败')
        }
      } catch (e) {
        this.list = []
        this.$message && this.$message.error('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },
    goDetail(item) {
      this.$router.push('/new_announcement/' + item.id)
    }
  }
}
</script>

<style scoped>
.gx-ann { min-height: 100vh; background: #F5F6FA; }
.gx-ann__back {
  border: none; background: transparent; color: #fff; cursor: pointer; font-size: 13px;
  display: inline-flex; align-items: center; gap: 4px;
}
.gx-ann__box { max-width: 960px; margin: 0 auto; padding: 24px 20px 48px; }
.gx-ann__head { display: flex; align-items: baseline; gap: 12px; margin-bottom: 18px; }
.gx-ann__title { margin: 0; font-size: 22px; color: #1A1A2E; }
.gx-ann__unread { font-size: 13px; color: #C8443C; font-weight: 600; }
.gx-ann__filters { display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }
.gx-ann__tabs { display: flex; gap: 6px; background: #fff; padding: 4px; border-radius: 10px; }
.gx-ann__tab {
  border: none; background: transparent; padding: 6px 14px; border-radius: 8px;
  font-size: 13px; color: #5A6478; cursor: pointer;
}
.gx-ann__tab--on { background: #C8443C; color: #fff; font-weight: 600; }
.gx-ann__list { min-height: 200px; }
.gx-ann__empty { padding: 64px 0; text-align: center; color: #8A95B0; }
.gx-ann__empty-icon { font-size: 36px; margin-bottom: 8px; }
.gx-ann__item {
  position: relative;
  display: flex;
  gap: 14px;
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px 14px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: box-shadow .15s;
}
.gx-ann__item:hover { box-shadow: 0 6px 18px rgba(26,26,46,.08); }
.gx-ann__item--unread { background: #FFFBF5; }
.gx-ann__dot {
  position: absolute; left: 8px; top: 22px;
  width: 6px; height: 6px; border-radius: 50%; background: #C8443C;
}
.gx-ann__cover {
  width: 120px; aspect-ratio: 16/9; border-radius: 8px; overflow: hidden; flex-shrink: 0; background: #EEF1F7;
}
.gx-ann__cover img { width: 100%; height: 100%; object-fit: cover; display: block; }
.gx-ann__body { flex: 1; min-width: 0; }
.gx-ann__row { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.gx-ann__tag {
  font-size: 11px; font-weight: 600; padding: 1px 7px; border-radius: 4px;
  background: #EEF1F7; color: #5A6478; flex-shrink: 0;
}
.gx-ann__tag--update { background: rgba(64,128,255,.12); color: #3A6FE0; }
.gx-ann__tag--activity { background: rgba(255,122,40,.12); color: #E06A1A; }
.gx-ann__tag--important { background: rgba(220,60,60,.12); color: #C8443C; }
.gx-ann__item-title {
  flex: 1; font-size: 15px; font-weight: 600; color: #1A1A2E;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.gx-ann__time { font-size: 12px; color: #A8B0C2; flex-shrink: 0; }
.gx-ann__summary {
  margin: 0; font-size: 13px; color: #6A6A8A; line-height: 1.6;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.gx-ann__pager { display: flex; justify-content: center; margin-top: 20px; }
</style>
